module.exports = require('./lib').bnch.CharPickerData;
